/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { FiEyeOff, FiEye } from 'react-icons/fi';
import * as S from '../../styles';

export interface IPasswordInputProps {
  id: string;
  label?: string;
  value?: string;
  errorText?: string;
  required?: boolean;
  placeholder?: string;
  labelColor?: string;
  hasError?: boolean;
  onCompChange?(id: string, payload: any): void;
}

export const PasswordInput = ({
  id,
  label,
  errorText,
  value,
  required,
  placeholder,
  onCompChange,
  labelColor,
  hasError,
}: IPasswordInputProps) => {
  const [textValue, setTextValue] = useState(value ?? '');
  const [passwordType, setPasswordType] = useState('password');
  const onChange = (id: string, e: any) => {
    setTextValue(e?.target?.value);
    onCompChange && onCompChange(id, e?.target?.value);
  };
  const _renderLabelIf = () => {
    if (label) {
      return (
        <S.FormLabel color={labelColor}>
          {label}
          {required && <sup style={{ color: 'red' }}>*</sup>}
        </S.FormLabel>
      );
    }
    return null;
  };

  const togglePassword = () => {
    if (passwordType === 'password') {
      setPasswordType('text');
      return;
    }
    setPasswordType('password');
  };

  const _renderErrorTextIf = () => {
    if (hasError && errorText) {
      return (
        <S.FeedbackOtherLabel type="tooltip">{errorText}</S.FeedbackOtherLabel>
      );
    }
    if (errorText) {
      return <S.FeedbackLabel type="invalid">{errorText}</S.FeedbackLabel>;
    }
    return null;
  };

  return (
    <>
      <Form.Group id={id} className="formgroup">
        {_renderLabelIf()}
        <InputGroup>
          <Form.Control
            className="formcontrol shadow-none"
            value={textValue}
            onChange={onChange.bind(null, id)}
            required={required}
            type={passwordType}
            placeholder={placeholder}
          />
          <InputGroup.Text
            style={{ border: 'none', cursor: 'pointer' }}
            onClick={togglePassword}
          >
            {passwordType === 'password' ? (
              <FiEyeOff size={15} />
            ) : (
              <FiEye size={15} />
            )}
          </InputGroup.Text>
          {_renderErrorTextIf()}
        </InputGroup>
      </Form.Group>
    </>
  );
};

PasswordInput.defaultProps = {
  required: false,
  hasError: false,
};
